import React from 'react'
import { Route, Routes } from 'react-router-dom'
import AdminOrder from '../../components/AdminOrders/AdminOrder'
import AdminOrderView from '../../components/AdminOrders/AdminOrderView'

const AdminOrders = () => {
  return (
    <div className='w-full h-full'>
      <Routes>
        <Route path='view_orders' element={<AdminOrder/>}/>
        <Route path='view_order/:id' element={<AdminOrderView/>}/>

      </Routes>
    </div>
  )
}

export default AdminOrders